// Returns a new array of themes sorted alphabetically by name.
// Handles null/undefined input by returning an empty array.
export function sortThemesByName(themes) {
    if (!themes) return [];
    return [...themes].sort((a, b) => a.name.localeCompare(b.name));
}
